interface FooterProps {
  footer: {
    text: string;
    brand: string;
  };
}

export function Footer({ footer }: FooterProps) {
  return (
    <p className="text-muted-foreground text-xs">
      {footer.text} <b>{footer.brand}</b>
    </p>
  );
}
